import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import ListKafka from 'components/Kafka/ListKafka';

const Kafka = (props) => {
  const {t} = props;

  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <ListKafka />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("kafka")(Kafka);
